import React from 'react';

export function MetricBar({
  name, value, max = 100, display, tone = 'data', benchmark,
  benchmarkLabel, state = 'measured', className = '', ...rest
}) {
  const pct = state === 'measured' && value != null ? Math.max(0, Math.min(100, (value / max) * 100)) : 0;
  return (
    <div className={['sp-meter', tone !== 'data' && 'sp-meter--' + tone, className].filter(Boolean).join(' ')} {...rest}>
      {(name || display) && (
        <div className="sp-meter__head">
          <span className="sp-meter__name">{name}</span>
          <span className="sp-meter__val" style={state !== 'measured' ? { color: 'var(--text-muted)' } : undefined}>
            {state === 'unknown' ? 'unknown' : state === 'placeholder' ? '—' : display}
          </span>
        </div>
      )}
      <div className="sp-meter__track">
        {state === 'measured'
          ? <div className="sp-meter__fill" style={{ width: pct + '%' }} />
          : <div className="sp-meter__fill sp-meter__fill--unknown" />}
        {benchmark != null && state === 'measured' && (
          <span
            className="sp-meter__bench"
            data-label={benchmarkLabel}
            style={{ left: Math.max(0, Math.min(100, (benchmark / max) * 100)) + '%' }}
          />
        )}
      </div>
    </div>
  );
}
